import { TriggerCategorizeDealItemsDocument } from '@/lib/graphql/generated/graphql';
import { trackEvent } from '@/lib/mixpanel';
import { toggleUpdatingField } from '@/lib/utils/updating-fields';
import { productsMapState } from '@/states/products.state';
import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';

export const useTriggerCategorizeDealItems = (dealId: string) => {
  const [triggerCategorizeDealItemsMutation, { loading, error }] = useMutation(
    TriggerCategorizeDealItemsDocument
  );
  const setProductsMap = useSetAtom(productsMapState);

  const triggerCategorizeDealItems = async (
    dealItemsIds: string[],
    forceRecategorize: boolean
  ) => {
    const idsSet = new Set(dealItemsIds);
    const applyUpdatingField = (add: boolean) =>
      setProductsMap((prev) =>
        toggleUpdatingField(prev, idsSet, 'productCategory', add)
      );

    applyUpdatingField(true);
    trackEvent('AI_CATEGORIZE_STARTED', {
      dealId,
      itemCount: dealItemsIds.length,
      forceRecategorize,
    });
    try {
      const result = await triggerCategorizeDealItemsMutation({
        variables: { dealId, dealItemsIds, forceRecategorize },
      });
      trackEvent('AI_CATEGORIZE_COMPLETED', {
        dealId,
        itemCount: dealItemsIds.length,
      });
      return result;
    } catch (err) {
      applyUpdatingField(false);
      throw err;
    }
  };

  return {
    triggerCategorizeDealItems,
    loading,
    error,
  };
};
